import {observable} from 'mobx';
import {DomainObject} from 'shared/store';

class OfferTemplateSummary extends DomainObject {
  @observable name;
}

export default OfferTemplateSummary;
